import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { httpOptions } from "./headers";

@Injectable({
    providedIn: 'root'
  })
  export class AlertMessageService {
  
    private alertMessageUrl = environment.alertMessageUrl;
  
    constructor(private http: HttpClient) { }
  
    getAlertMessage() : Observable<any> {
      return this.http.get<any>(this.alertMessageUrl,httpOptions);
    }

}